import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MoreIcon from '../../assets/Feed/MoreIcon';
import { api } from '../../services/api';
import { timeSinceFormatter } from '../../utils/formatter';
import DeleteModal from '../Modals/DeleteModal';
import PostOptionsModal from '../Modals/PostOptionsModal';
import SharePostModal from '../Modals/SharePostModal';
import UserIcon from '../UserIcon';
import { Container, FollowText, RightTopContainer, TimeSince, TopIconWrapper, UserContainer, UserName, UserNameContainer } from './styles';

type UserProps = {
  icon: string;
  username: string;
  light?: boolean;
  timeSince?: string;
  horizontal?: boolean;
  follow?: boolean;
  options?: boolean;
  select?: boolean
  selected?: boolean;
  publicationId?: string;
}

export default function User({ icon, username, light, timeSince, horizontal, follow, options, select, publicationId }: UserProps) {
  const [showOptions, setShowOptions] = useState(false);
  const navigate = useNavigate();
  const [postModal, setPostModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const navigateProfile = () => {
    navigate(`/Profile/${username}`);
  }

  const handleModalActions = async (action: string) => {
    if (action === 'post') {
      setPostModal(!postModal);
    } else if (action === 'share') {
      setShareModal(!shareModal);
    } else if (action === 'delete') {
      setPostModal(false);
      setDeleteModal(!deleteModal);
    } else if (action === 'confirmDelete') {
      try {
        api.delete(`/media/publication/${publicationId}`)
      } catch (error) {
        console.log(error)
      }
      setDeleteModal(!deleteModal);
    } else if (action === 'noDelete') {
      setDeleteModal(!deleteModal);
    }
  }

  return (
    <Container>
      <UserContainer onClick={() => navigateProfile()}>
        <UserIcon icon={icon} size={timeSince ? 'l' : 'm'} />
        <UserNameContainer style={horizontal ? { flexDirection: 'row', gap: '8px', alignItems: 'center' } : {}}>
          <UserName style={light ? { color: '#FCFCFC' } : {}}>{username}</UserName>
          {timeSince &&
            <TimeSince style={light ? { color: '#D9D9D9' } : {}} >{`${timeSinceFormatter(timeSince)}`}</TimeSince>
          }
        </UserNameContainer>
      </UserContainer>
      {follow &&
        <RightTopContainer>
          <FollowText>Seguir</FollowText>
          {options &&
            <TopIconWrapper onClick={() => setPostModal(!postModal)}>
              <MoreIcon />
            </TopIconWrapper>
          }
          <div style={{ position: 'absolute', width: '100%' }}>
            <PostOptionsModal open={postModal} authorUsername={username} onAction={handleModalActions} />
            {shareModal && <SharePostModal authorUsername={username} id={publicationId ? publicationId : 'eugehaguha'} open={shareModal} onClose={setShareModal} />}
            {deleteModal && <DeleteModal onAction={handleModalActions} />}
          </div>
        </RightTopContainer>
      }
    </Container>
  )
}